import { render, staticRenderFns } from "./bank-accounts.vue?vue&type=template&id=20a6743e&"
import script from "./bank-accounts.vue?vue&type=script&lang=js&"
export * from "./bank-accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20a6743e')) {
      api.createRecord('20a6743e', component.options)
    } else {
      api.reload('20a6743e', component.options)
    }
    module.hot.accept("./bank-accounts.vue?vue&type=template&id=20a6743e&", function () {
      api.rerender('20a6743e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/bank-accounts.vue"
export default component.exports